import { PaperActions } from "../action-types/paperActionType";

export const getPaperData = (payload) => {
    return {
        type: PaperActions.GET_PAPER_DATA,
        payload,
    };
};

export const setPaperData = (payload) => {
    return {
        type: PaperActions.SET_PAPER_DATA,
        payload,
    };
};